import client from './client';

/**
 * Report 01: Get image path overview
 */
export const getOverview = async (filters = {}) => {
  const { brands = [], categories = [], seasons = [], search = '' } = filters;
  const params = {};
  if (brands.length > 0) params.brand = brands.join(',');
  if (categories.length > 0) params.category = categories.join(',');
  if (seasons.length > 0) params.season = seasons.join(',');
  if (search) params.search = search;
  return await client.get('/api/reports/overview', { params });
};

/**
 * Report 02: Get coverage by season
 */
export const getCoverageBySeason = async (filters = {}) => {
  const { brands = [], categories = [], seasons = [], search = '' } = filters;
  const params = {};
  if (brands.length > 0) params.brand = brands.join(',');
  if (categories.length > 0) params.category = categories.join(',');
  if (seasons.length > 0) params.season = seasons.join(',');
  if (search) params.search = search;
  return await client.get('/api/reports/coverage/season', { params });
};

/**
 * Report 03: Get coverage by category
 */
export const getCoverageByCategory = async (filters = {}) => {
  const { brands = [], categories = [], seasons = [], search = '' } = filters;
  const params = {};
  if (brands.length > 0) params.brand = brands.join(',');
  if (categories.length > 0) params.category = categories.join(',');
  if (seasons.length > 0) params.season = seasons.join(',');
  if (search) params.search = search;
  return await client.get('/api/reports/coverage/category', { params });
};

/**
 * Report 04: Get missing images detail
 */
export const getMissingImages = async (params = {}) => {
  const { limit = 100, offset = 0, brands = [], categories = [], seasons = [], search = '' } = params;
  const requestParams = { limit, offset };
  if (brands.length > 0) requestParams.brand = brands.join(',');
  if (categories.length > 0) requestParams.category = categories.join(',');
  if (seasons.length > 0) requestParams.season = seasons.join(',');
  if (search) requestParams.search = search;
  return await client.get('/api/reports/missing-images', {
    params: requestParams
  });
};

/**
 * Report 05: Get coverage by collection
 */
export const getCoverageByCollection = async (filters = {}) => {
  const { brands = [], categories = [], seasons = [], search = '' } = filters;
  const params = {};
  if (brands.length > 0) params.brand = brands.join(',');
  if (categories.length > 0) params.category = categories.join(',');
  if (seasons.length > 0) params.season = seasons.join(',');
  if (search) params.search = search;
  return await client.get('/api/reports/coverage/collection', { params });
};

/**
 * Report 06: Get recent modifications
 */
export const getRecentUpdates = async (limit = 50, filters = {}) => {
  const { brands = [], categories = [], seasons = [], search = '' } = filters;
  const params = { limit };
  if (brands.length > 0) params.brand = brands.join(',');
  if (categories.length > 0) params.category = categories.join(',');
  if (seasons.length > 0) params.season = seasons.join(',');
  if (search) params.search = search;
  return await client.get('/api/reports/recent-updates', { params });
};

/**
 * Report 07: Get coverage timeline
 */
export const getCoverageTimeline = async (filters = {}) => {
  const { brands = [], categories = [], seasons = [], search = '' } = filters;
  const params = {};
  if (brands.length > 0) params.brand = brands.join(',');
  if (categories.length > 0) params.category = categories.join(',');
  if (seasons.length > 0) params.season = seasons.join(',');
  if (search) params.search = search;
  return await client.get('/api/reports/timeline', { params });
};

/**
 * Report 08: Get priority missing images
 */
export const getPriorityItems = async (limit = 100, filters = {}) => {
  const { brands = [], categories = [], seasons = [], search = '' } = filters;
  const params = { limit };
  if (brands.length > 0) params.brand = brands.join(',');
  if (categories.length > 0) params.category = categories.join(',');
  if (seasons.length > 0) params.season = seasons.join(',');
  if (search) params.search = search;
  return await client.get('/api/reports/priority-items', { params });
};

/**
 * Report 09: Get data quality metrics
 */
export const getQualityMetrics = async (filters = {}) => {
  const { brands = [], categories = [], seasons = [], search = '' } = filters;
  const params = {};
  if (brands.length > 0) params.brand = brands.join(',');
  if (categories.length > 0) params.category = categories.join(',');
  if (seasons.length > 0) params.season = seasons.join(',');
  if (search) params.search = search;
  return await client.get('/api/reports/quality-metrics', { params });
};

/**
 * Report 10: Get items with images detail
 */
export const getItemsWithImages = async (params = {}) => {
  const { limit = 100, offset = 0, brands = [], categories = [], seasons = [], search = '' } = params;
  const requestParams = { limit, offset };
  if (brands.length > 0) requestParams.brand = brands.join(',');
  if (categories.length > 0) requestParams.category = categories.join(',');
  if (seasons.length > 0) requestParams.season = seasons.join(',');
  if (search) requestParams.search = search;
  return await client.get('/api/reports/items-with-images', {
    params: requestParams
  });
};

/**
 * Fetch all dashboard data
 */
export const fetchAllDashboardData = async (filters = {}) => {
  const [
    overview,
    seasonCoverage,
    categoryCoverage,
    collectionCoverage,
    timeline,
    recentUpdates,
    priorityItems,
    qualityMetrics
  ] = await Promise.all([
    getOverview(filters),
    getCoverageBySeason(filters),
    getCoverageByCategory(filters),
    getCoverageByCollection(filters),
    getCoverageTimeline(filters),
    getRecentUpdates(50, filters),
    getPriorityItems(100, filters),
    getQualityMetrics(filters)
  ]);

  return {
    overview,
    seasonCoverage,
    categoryCoverage,
    collectionCoverage,
    timeline,
    recentUpdates,
    priorityItems,
    qualityMetrics
  };
};
